import { render, staticRenderFns } from "./MonthlyTaxSubmissionRecordNew.vue?vue&type=template&id=40b41989"
import script from "./MonthlyTaxSubmissionRecordNew.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxSubmissionRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports